module.exports = __webpack_public_path__ + "static/media/Sheryl Yang.4d8855e6.png";